import { createSelector, createSlice } from "@reduxjs/toolkit";
import * as Auth from 'aws-amplify/auth';
import { reset } from "./globalActions";

export function isAlreadySignedInError(ex) {
    if (typeof ex?.message !== "string") return false;

    return ex.message.includes('There is already a signed in user.');
}

const moduleName = "auth";

const initialState = {
    loading: false,
    user: false,
    totpCode: "",
};

const userSlice = createSlice({
    name: "auth",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(reset, () => initialState);
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setUser: (state, action) => {
            state.loading = false;
            state.user = action.payload || false;
        },
        setTOTP: (state, action) => {
            state.totpCode = action.payload;
        },
    },
});

export const { setLoading, setUser, setTOTP } = userSlice.actions;
export default userSlice.reducer;

export const selectState = (state) => state[moduleName];
export const selectUser = createSelector(selectState, (state) => state.user);
export const selectTotpCode = createSelector(selectState, (state) => state.totpCode);
export const selectLoading = createSelector(selectState, (state) => state.loading);

export const fetchUser =
    (): any =>
        async (dispatch): Promise<any> => {
            const user = await Auth.getCurrentUser();
            dispatch(setUser(user));
            return user;
        };

export const login =
    (username, password): any =>
        async (dispatch): Promise<any> => {
            try {
                const user = await Auth.signIn({ username, password });
                dispatch(setUser(user));
                return user;
            } catch (ex) {
                if (isAlreadySignedInError(ex)) {
                    await Auth.signOut();
                    const user = await Auth.signIn({ username, password });
                    dispatch(setUser(user));
                    return user;
                }
                throw ex;
            }
        };

export const logout =
    (): any =>
        async (dispatch): Promise<any> => {
            try {
                await Auth.signOut();
                dispatch(reset());
            } catch (ex) {
                console.log('failed to logout', ex);
            }
        };

// export const register =
//     (username, password): any =>
//         async (dispatch): Promise<any> => {
//             try {
//                 const user = await Auth.signUp({
//                     username,
//                     password,
//                     autoSignIn: {
//                         enabled: false,
//                     },
//                 });
//                 dispatch(setUser(user));
//                 return user;
//             } catch (ex) {
//                 console.log("ex", ex);
//                 alert(`Failed to register: ${ex.message}`);
//             }
//         };

// export const confirmSignUp =
//     (username, code, clientMetadata): any =>
//         async (): Promise<any> => {
//             try {
//                 await Auth.confirmSignUp(username, code, { clientMetadata });
//             } catch (ex) {
//                 console.log("ex", ex);
//                 alert(`Failed to confirm sign up: ${ex.message}`);
//             }
//         };

// export const confirmSignIn =
//     (code, challengeName): any =>
//         async (dispatch, getState): Promise<any> => {
//             try {
//                 const user = selectUser(getState());
//                 await Auth.confirmSignIn(user, code, challengeName);
//             } catch (ex) {
//                 console.log("ex", ex);
//                 alert(`Failed to get TOTP code: ${ex.message}`);
//             }
//         };

// export const getTOTPCode =
//     (): any =>
//         async (dispatch, getState): Promise<any> => {
//             try {
//                 // const user = await Auth.currentAuthenticatedUser();
//                 const code = await Auth.setupTOTP(user);
//                 dispatch(setTOTP(code));
//                 return code;
//             } catch (ex) {
//                 console.log("ex", ex);
//                 alert(`Failed to get TOTP code: ${ex.message}`);
//             }
//         };

// export const verifyTOTPCode =
//     (code): any =>
//         async (dispatch, getState): Promise<any> => {
//             try {
//                 // const user = await Auth.currentAuthenticatedUser();
//                 await Auth.verifyTotpToken(user, code);
//                 await Auth.setPreferredMFA(user, "TOTP");
//             } catch (ex) {
//                 console.log("ex", ex);
//                 alert(`Failed to verify TOTP code: ${ex.message}`);
//             }
//         };

export const newPassword =
    (password): any =>
        async (dispatch, getState): Promise<any> => {
            return await Auth.confirmSignIn({
                challengeResponse: password
            })
        };
